import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BusinessList = _resolveComponent("BusinessList")!

  return (_openBlock(), _createBlock(_component_BusinessList, {
    tabPanelData: _ctx.tabList,
    pageTypeIn: 'QUOTE',
    permission: "QUOTED_BUSINESS",
    canCommand: false,
    marketFeeCanCommand: false,
    FilterFieldProps: _ctx.FilterField,
    businessTypeName: "TABLE_QUOTED_BUSINESS",
    HiddenFieldFunProps: (item) => '内部订单号、发票号码、发票金额、紧急程度、预计完成天数、维修类型、业务类型、业务分类、开票日期、业务状态、开票状态、收款状态、收款日期'.split('、').some(fieldName => fieldName === item.fieldName)
  }, null, 8, ["tabPanelData", "FilterFieldProps", "HiddenFieldFunProps"]))
}